const StateType = {
  none: 'none',
  enable: 'enable',
  disable: 'disable',
  error: 'error',
  readonly: 'readonly'
}

export default StateType;
